import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Button, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  addBrand,
  getAllBrands,
  getAllBrandsList,
  getSale,
  updateDeliveryTime,
} from "../../../redux/features/assetManagementSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DeliveryDate = ({ dispatchParams, rowData,notPendingStage }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.assetmanagement);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      expectedDelivery: rowData.expectedDeliveryDate
        ? dayjs(rowData.expectedDeliveryDate)
        : null,
      delivery_from_time: rowData.expectedDeliveryFromTime
        ? dayjs(`1970-01-01T${rowData.expectedDeliveryFromTime}`)
        : null,
      delivery_to_time: rowData.expectedDeliveryToTime
        ? dayjs(`1970-01-01T${rowData.expectedDeliveryToTime}`)
        : null,

      salesID: rowData.salesID,
    },
    onSubmit: (values) => {
      const formattedValues = {
        ...values,
        delivery_from_time: values.delivery_from_time
          ? dayjs(values.delivery_from_time).format("HH:mm:ss")
          : null,
        delivery_to_time: values.delivery_to_time
          ? dayjs(values.delivery_to_time).format("HH:mm:ss")
          : null,
        expectedDelivery: values.expectedDelivery
          ? dayjs(values.expectedDelivery).format("YYYY-MM-DD")
          : null,
      };

      dispatch(updateDeliveryTime(formattedValues)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getSale(dispatchParams));
          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Date & Time"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <Button
          disabled={notPendingStage}
          size="medium"
          variant="outlined"
          color="secondary"
          onClick={() => setOpen(true)}
          sx={{
            gap: "5px",
          }}
        >
          <Icon icon={"mdi:calendar-time"} width={20} height={20} />
          Delivery Date
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date"
                      value={formik.values.expectedDelivery}
                      onChange={(newValue) => {
                        formik.setFieldValue("expectedDelivery", newValue);
                      }}
                      onBlur={formik.handleBlur}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error:
                            formik.touched.expectedDelivery &&
                            Boolean(formik.errors.expectedDelivery),
                          helperText:
                            formik.touched.expectedDelivery &&
                            formik.errors.expectedDelivery,
                        },
                      }}
                      minDate={dayjs()}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="delivery_from_time"
                      label="From Time"
                      value={formik.values.delivery_from_time}
                      onChange={(newValue) =>
                        formik.setFieldValue("delivery_from_time", newValue)
                      }
                      onBlur={() =>
                        formik.setFieldTouched("delivery_from_time", true)
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          onKeyDown: (e) => e.preventDefault(),
                          error:
                            formik.touched.delivery_from_time &&
                            Boolean(formik.errors.delivery_from_time),
                          helperText:
                            formik.touched.delivery_from_time &&
                            formik.errors.delivery_from_time,
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="delivery_to_time"
                      label="To Time"
                      value={formik.values.delivery_to_time}
                      onChange={(newValue) =>
                        formik.setFieldValue("delivery_to_time", newValue)
                      }
                      onBlur={() =>
                        formik.setFieldTouched("delivery_to_time", true)
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          onKeyDown: (e) => e.preventDefault(),
                          error:
                            formik.touched.delivery_to_time &&
                            Boolean(formik.errors.delivery_to_time),
                          helperText:
                            formik.touched.delivery_to_time &&
                            formik.errors.delivery_to_time,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default DeliveryDate;
